import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO = ({ type = 'website', description = '', lang = 'en', meta = [], image, title, children }) => {
    const location = useLocation();

    const metaTags = [
        {
            name: `description`,
            content: description
        },
        {
            property: `og:title`,
            content: title
        },
        {
            property: `og:description`,
            content: description
        },
        {
            property: `og:type`,
            content: type
        },
        {
            property: `og:image`,
            content: image || `${location.origin}/logo192.png`
        },
        {
            property: 'og:url',
            content: location.href
        }
    ].concat(meta);

    return (
        <Helmet titleTemplate={`%s | AudioEngine Gateway`}>
            <title>{title}</title>
            {metaTags.map((tag) => (
                <meta key={tag.name || tag.property} {...tag} />
            ))}
            {children}
        </Helmet>
    );
};

export default SEO;
